import {
  Box,
  ContentLayout,
  Layout,
  Stack,
  ThemeProvider,
  darkTheme,
  lightTheme,
} from "@strapi/design-system";
import React, { useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import ChangePassword from "./components/ChangePassword";
import {
  default as CloseNomination,
  default as Secrectariat,
} from "./components/CloseNomination";
import EmailConfirmation from "./components/EmailConfirmation";
import ForgotPassword from "./components/ForgotPassword";
import Home from "./components/Home";
import Login from "./components/Login";
import Profile from "./components/Profile";
import ActAsUser from "./components/ActAsUser";
import ResetPassword from "./components/ResetPassword";
import SignUp from "./components/Signup";
import Header from "./components/layout/Header";
import store from "./redux/store";
import Footer from "./components/layout/Footer";
import EmailManagement from "./components/EmailManagement";

function App() {
  const persistor = persistStore(store);
  const [theme, setTheme] = useState("light");

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
            <Stack height="100vh" background="neutral100">
              <Box background="neutral100">
                <Layout>
                  <>
                    <Header />
                    <ContentLayout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                          path="/nomination/sign-up"
                          element={<SignUp lng="en" />}
                        />
                        <Route
                          path="/nomination/dang-ky"
                          element={<SignUp lng="vi" />}
                        />

                        <Route
                          index
                          path="/nomination/dang-nhap"
                          element={<Login lng="vi" />}
                        />
                        <Route
                          index
                          path="/nomination/login"
                          element={<Login lng="en" />}
                        />

                        <Route
                          path="/nomination/profile"
                          element={<Profile lng="en" />}
                        />
                        <Route
                          path="/nomination/act-as-user"
                          element={<ActAsUser lng="en" />}
                        />
                        <Route
                          path="/nomination/ho-so"
                          element={<Profile lng="vi" />}
                        />

                        <Route
                          path="/nomination/secretariat"
                          element={<Secrectariat lng="en" />}
                        />
                        <Route
                          path="/nomination/ban-thu-ky"
                          element={<Secrectariat lng="vi" />}
                        />

                        <Route
                          path="/nomination/close-nomination"
                          element={<CloseNomination lng="en" />}
                        />
                        <Route
                          path="/nomination/dong-de-cu"
                          element={<CloseNomination lng="vi" />}
                        />

                        <Route
                          path="/nomination/email-management"
                          element={<EmailManagement lng="en" />}
                        />
                        <Route
                          path="/nomination/quan-ly-email"
                          element={<EmailManagement lng="vi" />}
                        />

                        <Route
                          path="/nomination/email-confirmation"
                          element={<EmailConfirmation lng="en" />}
                        />
                        <Route
                          path="/nomination/xac-thuc-mat-khau"
                          element={<EmailConfirmation lng="vi" />}
                        />

                        <Route
                          path="/nomination/change-password"
                          element={<ChangePassword lng="en" />}
                        />
                        <Route
                          path="/nomination/doi-mat-khau"
                          element={<ChangePassword lng="vi" />}
                        />

                        <Route
                          path="/nomination/forgot-password"
                          element={<ForgotPassword lng="en" />}
                        />

                        <Route
                          path="/nomination/quen-mat-khau"
                          element={<ForgotPassword lng="vi" />}
                        />

                        <Route
                          path="/nomination/reset-password"
                          element={<ResetPassword lng="en" />}
                        />
                        <Route
                          path="/nomination/dat-lai-mat-khau"
                          element={<ResetPassword lng="vi" />}
                        />
                      </Routes>
                    </ContentLayout>
                    <Footer/>
                  </>
                </Layout>
              </Box>
            </Stack>
          </ThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
